/* global axios */
import ApiClient from './ApiClient';

class GupshupTemplatesAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  resourcePath(inboxId) {
    return `${this.baseUrl()}/inboxes/${inboxId}/gupshup_templates`;
  }

  list(inboxId) {
    return axios.get(this.resourcePath(inboxId));
  }

  create(inboxId, payload) {
    return axios.post(this.resourcePath(inboxId), {
      gupshup_template: payload,
    });
  }

  update(inboxId, chatwootId, payload) {
    return axios.patch(`${this.resourcePath(inboxId)}/${chatwootId}`, {
      gupshup_template: payload,
    });
  }

  destroy(inboxId, chatwootId) {
    return axios.delete(`${this.resourcePath(inboxId)}/${chatwootId}`);
  }

  fetchConfiguration(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`);
  }

  connect(inboxId, payload) {
    return axios.put(`${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`, {
      gupshup_configuration: payload,
    });
  }

  disconnect(inboxId) {
    return axios.delete(`${this.baseUrl()}/inboxes/${inboxId}/gupshup_configuration`);
  }
}

export default new GupshupTemplatesAPI();
